import React, { useEffect, useState, useContext } from "react";
import _ from "lodash";
import Form from "forms/Form";
import MainContext from "context/MainContext";
import { CHANNELS, CLOSED_CAPTIONS, EVENTS } from "api/config/endpoints";
import { getLanguages, getLiveCcLanguages } from "api/functions/functions";
import formWrapper from "hoc/formWrapper";
import { InlineLoading } from "carbon-components-react";
import { useParams } from "react-router-dom";


const ClosedCaptionForm = (props) => {
    const { event } = useParams()
    const context = useContext(MainContext)
    const [itemId, setItemId] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [languages, setLanguages] = useState([])
    // const [selectedLang, setSelectedLang] = useState("en")
    const [selectedLangCode, setSelectedLangCode] = useState("en")
    const [defaultValues, setDefaultValues] = useState({});

    const endpoint = [
        EVENTS,
        event,
        CHANNELS,
        props.channelId,
        CLOSED_CAPTIONS
    ].join("/");

    useEffect(() => {
        async function fetchData() {
            let langs = []
            switch (props.eventType) {
                case 1:
                    langs = await getLiveCcLanguages()
                    break
                default:
                    langs = await getLanguages()
            }

            setLanguages(langs)
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (_.isEmpty(languages)) {
            return false
        }
        // setSelectedLang("en")
        setSelectedLangCode("en")
    }, [languages])

    useEffect(() => {
        let data = { ...props.defaultValues }
        console.log("defaultValues", props.defaultValues)
        setItemId(_.get(props, "defaultValues.id"))
        setDefaultValues(data)
        setLoaded(true)
    }, [props.defaultValues]);


    const getValue = (name, type) => {
        let value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;

        if (["title"].includes(name)) { //"title", 
            value = _.get(value, selectedLangCode)
        }
        switch (type) {
            case "bool":
                return value !== 0;
            default:
                return value;
        }
    };

    const onSubmit = (data) => {

        if (!_.isEmpty(data) && data !== defaultValues) {
            setDefaultValues(data)
            try {
                setItemId(data.id)
            }
            catch (e) {
                console.error("EEEEEEEEE")
            }
        }
        // const toast = (
        //     <Toast
        //         key={moment().format("X")}
        //         kind="success"
        //         title="Changes saved"
        //     />
        // )
        // context.addToast(toast)
        if (props.onItemChanged) {
            props.onItemChanged(data)
        }
    }

    const onlanguagechange = (e) => {
        try {
            const langCode = e.target.value
            // setSelectedLang(e.target.value)
            setSelectedLangCode(langCode)
        }
        catch (e) { }
    }

    const onLanguagesLoaded = (e) => {
        try {
            let defaultLanguage = null
            if (context.evt?.default_language) {
                defaultLanguage = context.evt.default_language
            }
            else {
                defaultLanguage = "en"
            }
            setSelectedLangCode(defaultLanguage)
        }
        catch (e) { }
    }

    let fields = [
        // {
        //     elementType: "input",
        //     id: "title",
        //     name: "title",
        //     labelText: "Title",
        //     value: getValue("title"),
        // },
        {
            elementType: "select",
            id: "lang_id",
            name: "lang_id",
            label: "CC Language",
            placeholder: "Select CC language",
            value: getValue("lang_id"),
            rules: {
                required: true,
            },
            items: languages,
        },
    ]

    return (
        <>
            {
                languages ? (
                    <>
                        {/* <LanguageSelector
                            // languages={languages}
                            selectedLangCode={selectedLangCode}
                            onChange={(e) => onlanguagechange(e)}
                            onLanguagesLoaded={(e) => onLanguagesLoaded(e)}
                        /> */}

                        <div className={props.className} key={`form-speaker-${itemId}-${selectedLangCode}`}>
                            <Form
                                blockTouched={true}
                                itemId={itemId}
                                fields={fields}
                                endpoint={endpoint}
                                loaded={loaded}
                                setAutoId={true}
                                // saveOnChange={true}
                                // hideSubmitButton={true}
                                hasStandardFooter={true}
                                defaultParams={{
                                    // lang_id: selectedLangCode,
                                    event_type: props.eventType
                                }}
                                onSubmit={(data) => onSubmit(data)}
                                abortButton={true}
                                onAbortClicked={props.onAbortClicked}
                                key={"speaker-form-" + itemId}
                            />
                        </div>
                    </>
                ) : (
                    <InlineLoading />
                )
            }
        </>
    );
};

export default ClosedCaptionForm;

export const WrappedChannelSourceForm = formWrapper(ClosedCaptionForm)
